import clx from 'classnames';
import { useFormContext, useController } from 'react-hook-form';
import SearchButton from '@/atoms/Button/SearchButton';
import Xclose from '@/atoms/Xclose';
import { InputProps } from './types';
import HTMLInput from '../Input/Text/HTMLInput';

interface SearchBarProps extends InputProps {
  onReset?: () => void;
}
const SearchBar = ({ label, name, className, onReset, ...inputProps }: SearchBarProps) => {
  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
  });

  return (
    <div className={clx(className, 'lg-medium text-neutral-900 w-full py-2 pr-2 flex gap-4 items-center')}>
      <div className="relative w-full">
        <HTMLInput {...inputProps} {...field} id={name} value={field.value || ''} />
        {field.value && field.value !== '' && onReset && (
          <Xclose className="absolute right-1 top-0 bottom-0 p-3 m-auto" onClick={onReset} />
        )}
      </div>
      <SearchButton />
    </div>
  );
};

export default SearchBar;
